
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_f8g6q_1ym4y_9",
  "embedded": "awsui_embedded_f8g6q_1ym4y_41",
  "tokens": "awsui_tokens_f8g6q_1ym4y_74",
  "dropdown-header": "awsui_dropdown-header_f8g6q_1ym4y_78",
  "dropdown-footer": "awsui_dropdown-footer_f8g6q_1ym4y_84"
};
  